import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { updateCustomerDetails } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import { getPanVerify } from '../../Utils/api';
import EmploymentDetail from './EmploymentDetail';
import MobileNav from '../../component/MobileNav';
import JourneyRightPanel from '../../component/JourneyRightPannel';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .pan-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .pan-page {
    min-height: 100vh;
    background: #eaf1fd;
    display: flex;
    flex-direction: column;
    font-family: 'Sora', sans-serif;
  }

  /* ── SPLIT LAYOUT ── */
  .pan-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    min-height: calc(100vh - 60px);
    margin-top: 50px;
  }

  /* ── LEFT PANEL ── */
  .pan-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem 3.5rem;
    background: #eaf1fd;
  }

  .pan-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 3rem;
  }
  .pan-logo-dot {
    width: 34px;
    height: 34px;
    background: #F97316;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pan-logo-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .pan-logo-name {
    font-size: 16px;
    font-weight: 600;
    color: #0f1c2e;
    letter-spacing: -0.2px;
  }

  .pan-card {
    background: #ffffff;
    border-radius: 24px;
    padding: 2.5rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
  }

  .pan-card-title {
    font-size: 22px;
    font-weight: 700;
    color: #0f1c2e;
    letter-spacing: -0.5px;
    margin-bottom: 4px;
  }
  .pan-card-sub {
    font-size: 13px;
    color: #6b7a90;
    margin-bottom: 2rem;
  }

  .pan-field-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: #6b7a90;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .pan-field-label .req { color: #F97316; }

  /* PAN BOXES */
  .pan-boxes-wrap {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: nowrap;
    margin-bottom: 6px;
  }
  .pan-sep-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #c8d3e2;
    flex-shrink: 0;
    margin: 0 2px;
  }
  .pan-box {
    width: 34px;
    height: 44px;
    border: 1.5px solid #dce4f0;
    border-radius: 10px;
    background: #f7f9fc;
    text-align: center;
    font-family: 'JetBrains Mono', monospace;
    font-size: 15px;
    font-weight: 500;
    color: #0f1c2e;
    caret-color: transparent;
    outline: none;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
    flex-shrink: 0;
  }
  .pan-box::placeholder { color: #c8d3e2; }
  .pan-box:focus {
    border-color: #378ADD;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(55,138,221,0.14);
  }
  .pan-box.has-val {
    border-color: #b8cce8;
    background: #fff;
  }
  .pan-box.pan-err {
    border-color: #E24B4A;
    background: #fff9f9;
    box-shadow: 0 0 0 3px rgba(226,75,74,0.1);
  }

  /* INCOME INPUT */
  .pan-income-wrap {
    position: relative;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .pan-rupee {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 15px;
    color: #6b7a90;
    pointer-events: none;
    font-family: 'Sora', sans-serif;
  }
  .pan-income-input {
    width: 100%;
    height: 48px;
    border: 1.5px solid #dce4f0;
    border-radius: 12px;
    background: #f7f9fc;
    padding: 0 14px 0 34px;
    font-family: 'Sora', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #0f1c2e;
    outline: none;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  }
  .pan-income-input::placeholder { color: #adb8ca; font-weight: 400; }
  .pan-income-input:focus {
    border-color: #378ADD;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(55,138,221,0.14);
  }
  .pan-income-input.pan-err {
    border-color: #E24B4A;
    background: #fff9f9;
    box-shadow: 0 0 0 3px rgba(226,75,74,0.1);
  }

  .pan-error-msg {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #E24B4A;
    margin-top: 6px;
    font-weight: 400;
  }
  .pan-error-msg svg { width: 13px; height: 13px; flex-shrink: 0; }

  /* CTA BUTTON */
  .pan-cta {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 14px;
    background: #F97316;
    color: #fff;
    font-family: 'Sora', sans-serif;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    letter-spacing: -0.1px;
  }
  .pan-cta:hover:not(:disabled) {
    background: #ea6a0a;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
  }
  .pan-cta:active:not(:disabled) { transform: scale(0.98); }
  .pan-cta:disabled { background: #c8d3e2; box-shadow: none; cursor: not-allowed; }
  .pan-cta svg { width: 18px; height: 18px; }

  /* TRUST BAR */
  .pan-trust {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 1.25rem;
    font-size: 11.5px;
    color: #9aaabb;
    font-weight: 400;
  }
  .pan-trust svg { width: 13px; height: 13px; color: #34d399; }
  .pan-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .pan-split { grid-template-columns: 1fr; min-height: auto; }
    .pan-right { display: none; }
    .pan-left { padding: 2rem 1.25rem 6rem; justify-content: flex-start; }
    .pan-logo { margin-bottom: 1.5rem; }
    .pan-card { padding: 1.75rem 1.5rem; }
    .pan-card-title { font-size: 20px; }
    .pan-boxes-wrap { gap: 4px; }
    .pan-box { width: 30px; height: 42px; font-size: 14px; }
    .pan-hero-h1 { font-size: 24px; }
  }

  @media (max-width: 400px) {
    .pan-box { width: 26px; height: 40px; font-size: 13px; border-radius: 8px; }
    .pan-boxes-wrap { gap: 3px; }
    .pan-card { padding: 1.5rem 1.25rem; }
  }
`;


const IconAlert = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

const IconBolt = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
);


export default function PanDetails() {
  const dispatch = useDispatch();
  const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);

  const [salary, setSalary] = useState('');
  const [isInvalidSalary, setIsInvalidSalary] = useState(false);
  const [isInvalidPan, setIsInvalidPan] = useState(false);
  const [errorPanMsg, setErrorPanMsg] = useState('');
  const [errorSalaryMsg, setErrorSalaryMsg] = useState('');
  const inputLength = 10;
  const [userpan, setUserPan] = useState(Array(inputLength).fill(''));
  const inputRefs = useRef([]);
  const [loader, setLoader] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [verifyBtn, setVerifyBtn] = useState(true);

  useEffect(() => {
    if (customerDetails?.pancard) {
      setUserPan(customerDetails.pancard.split(''));
      setVerifyBtn(false);
    }
    if (customerDetails?.monthly_income) {
      setSalary(customerDetails?.monthly_income);
    }
  }, [customerDetails?.pancard]);

  useEffect(() => {
    if (customerDetails?.pancard_verified_status === 1) {
      setUserInfo(true);
    }
  }, [customerDetails?.pancard_verified_status]);

  const handleChange = (e, index) => {
    setErrorPanMsg('');
    setIsInvalidPan(false);
    const value = e.target.value.toUpperCase();
    let isValidChar = false;
    if (index >= 0 && index <= 4) isValidChar = /^[A-Z]{1}$/.test(value);
    else if (index >= 5 && index <= 8) isValidChar = /^[0-9]{1}$/.test(value);
    else if (index === 9) isValidChar = /^[A-Z]{1}$/.test(value);

    if (isValidChar || value === '') {
      const updatedPan = [...userpan];
      updatedPan[index] = value;
      setUserPan(updatedPan);
      if (value && index < inputLength - 1) inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !userpan[index] && index > 0) {
      const updatedPan = [...userpan];
      updatedPan[index - 1] = '';
      setUserPan(updatedPan);
      inputRefs.current[index - 1].focus();
    }
  };

  const fullPan = userpan.join('');

  const handleVerifyPan = async () => {
    if (loader) return;
    const panValid = /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(fullPan);
    const salaryValid = /^\d+$/.test(salary) && parseInt(salary) > 0;

    setIsInvalidPan(!panValid);
    setIsInvalidSalary(!salaryValid);

    if (!panValid) { setErrorPanMsg("Please enter a valid 10-character PAN Number."); return; }
    else setErrorPanMsg('');

    if (!salaryValid) { setErrorSalaryMsg("Please enter a valid Monthly Income (numbers only)."); return; }
    else setErrorSalaryMsg('');

    const param = {
      profileId: customerDetails?.profileId || '',
      pancard: fullPan,
      monthlyIncome: salary,
    };

    try {
      setLoader(true);
      const response = await getPanVerify(param);
      if (response?.data?.apiStatus === 1) {
      
        toast.success(response?.data?.message);
        const apiData = response?.data?.data || {};
        dispatch(updateCustomerDetails({
          full_name: apiData?.name,
          dob: apiData?.dob,
          pancard: apiData?.panNumber,
          monthly_income: salary,
          gender: apiData?.gender
        }));
        setUserInfo(true);
      } else {
        toast.error(response?.data?.message || "Verification failed. Please check details.");
      }
    } catch (error) {
      console.error("PAN verification error:", error);
      toast.error("Error verifying PAN. Please check your connection or try again later.");
    } finally {
      setLoader(false);
    }
  };

  if (userInfo) return <EmploymentDetail />;

  const maskedPan = fullPan.length === 10
    ? fullPan.slice(0, 2) + 'XXX' + fullPan.slice(5, 7) + 'XXX' + fullPan.slice(9)
    : '';

  return (
    <>
      <style>{styles}</style>
      <div className="pan-page">
        <div className="pan-split">

          {/* ── LEFT: FORM ── */}
          <div className="pan-left">
           

            <div className="pan-card">
              <h1 className="pan-card-title">PAN verification</h1>
              <p className="pan-card-sub">Make sure your details are correct before you proceed.</p>

              {/* PAN BOXES */}
              <div style={{ marginBottom: '1.25rem' }}>
                <label className="pan-field-label">
                  PAN number <span className="req">*</span>
                </label>
                <div className="pan-boxes-wrap">
                  {userpan.map((char, i) => {
                    const isAlpha = (i >= 0 && i <= 4) || i === 9;
                    const showSep = i === 4 || i === 8;
                    return (
                      <React.Fragment key={i}>
                        <input
                          ref={(el) => (inputRefs.current[i] = el)}
                          value={char}
                          maxLength={1}
                          placeholder={isAlpha ? 'A' : '0'}
                          onChange={(e) => handleChange(e, i)}
                          onKeyDown={(e) => handleKeyDown(e, i)}
                          inputMode={isAlpha ? 'text' : 'numeric'}
                          pattern={isAlpha ? '[A-Za-z]*' : '[0-9]*'}
                          autoCapitalize="characters"
                          aria-label={`PAN character ${i + 1}`}
                          className={`pan-box ${isInvalidPan ? 'pan-err' : ''} ${char ? 'has-val' : ''}`}
                        />
                        {showSep && <span className="pan-sep-dot" aria-hidden="true" />}
                      </React.Fragment>
                    );
                  })}
                </div>
                {errorPanMsg && (
                  <p className="pan-error-msg">
                    <IconAlert /> {errorPanMsg}
                  </p>
                )}
              </div>

              {/* INCOME */}
              <div className="pan-income-wrap">
                <label className="pan-field-label" htmlFor="incomeField">
                  Monthly income <span className="req">*</span>
                </label>
                <span className="pan-rupee" aria-hidden="true">₹</span>
                <input
                  id="incomeField"
                  type="text"
                  value={salary}
                  inputMode="numeric"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,7}$/.test(value)) {
                      setSalary(value);
                      setIsInvalidSalary(false);
                      setErrorSalaryMsg('');
                    }
                  }}
                  className={`pan-income-input ${isInvalidSalary ? 'pan-err' : ''}`}
                  placeholder="e.g. 50000"
                />
                {errorSalaryMsg && (
                  <p className="pan-error-msg">
                    <IconAlert /> {errorSalaryMsg}
                  </p>
                )}
              </div>

              {/* CTA */}
              {/* {verifyBtn && ( */}
                <button
                  className="pan-cta"
                  onClick={handleVerifyPan}
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
                        </path>
                      </svg>
                      Verifying…
                    </>
                  ) : (
                    <>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                        <polyline points="9 12 11 14 15 10"/>
                      </svg>
                      Verify &amp; continue
                    </>
                  )}
                </button>
              {/* )} */}

              {/* TRUST */}
              <div className="pan-trust">
                <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                256-bit SSL encrypted
                <span className="pan-trust-sep" />
                Your data is private
                <span className="pan-trust-sep" />
                RBI compliant
              </div>
            </div>
          </div>

          {/* ── RIGHT: HERO ── */}
          <JourneyRightPanel/>
        </div>
      </div>
      <MobileNav />
    </>
  );
}